const routesMap = {
  base: process.env.VUE_APP_API_BASE_URL,
  admin: process.env.VUE_APP_BASE_URL,
  api: process.env.VUE_APP_API_BASE_URL,
  download: process.env.VUE_APP_API_BASE_URL + "/download",
  BankImage:
    "https://my." + process.env.VUE_APP_BASE_DOMAIN + "/media/BankImage/",
  myShepa: "https://my." + process.env.VUE_APP_BASE_DOMAIN,
  homeUrl: "https://" + process.env.VUE_APP_BASE_DOMAIN,
  outrules:
    "https://" +
    process.env.VUE_APP_BASE_DOMAIN +
    "/shepa_international_rules/",
  inrules: "https://" + process.env.VUE_APP_BASE_DOMAIN + "/shepa_rules/",
};
export default routesMap;
